import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JobSignatureService {

  constructor(
    protected httpClient: HttpClient
  ) { }
  async getJobSignature(id: string){
    const result: any = await this.httpClient.get(`plan/api/business/jobSignature/queryById/${id}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getJobSignatureListByJno(jno: string) {
    const result: any = await this.httpClient.get(`plan/api/business/jobSignature/queryByJno/${jno}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async addJobSignature(jobSignature: any) {
    return await this.httpClient.post('plan/api/business/jobSignature/add', jobSignature).toPromise();
  }
  async deleteJobSignature(id: string) {
    const result: any = await this.httpClient.delete(`plan/api/business/jobSignature/delete/${id}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
}
